// ----------------------------------------------------------
// © Copyright 2021 European Space Agency, 2021
// This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this [source code/executable] package. No part of the package, including this file, may be copied, modified, propagated, or distributed except according to the terms contained in the file ‘LICENSE.txt’.
// -----------------------------------------------------------
import { isUndefined, Logger } from "@datalabs/edl_common_ui";
const logger = new Logger("api", "REST");
export class RestApi {
  constructor() {
    this.backend = location.origin + "/api";
  }
  /**
   * Upload a list of files to the server, it must be associated with datablab
   * @param formData
   * @param datalab
   */
  uploadFiles(files, datalabId) {
    if (isUndefined(datalabId)) {
      throw new Error("Datalab must be set to upload files");
    }
    if (isUndefined(files) || files.length == 0) {
      throw new Error("You need to provide a list of files which is not empty");
    }
    const formData = new FormData();
    files.forEach((file, index) => {
      formData.append(`file${index}`, file, file.name);
    });
    return fetch(`${this.backend}/upload/${datalabId}`, {
      method: 'POST',
      body: formData
    }).then((response) => {
      if (response.status != 200) {
        logger.warn(`Files not uploaded with error ${response.status}`);
        return response.text();
      }
      logger.info(`Files uploaded`);
      return response.json();
    }, (reason) => {
      logger.warn(`Files not uploaded for ${reason}`);
      return { error: reason };
    }).catch(err => logger.error("Something failed:", err));
  }
}
const api = new RestApi();
// for backward compatibility
export { api };
// for mocking in tests
export default RestApi;
